import React from "react";

const EventsLoader = () => {
    return (
        <table className="rty-table loading">
            <thead>
                <tr>
                    <th>Event</th>
                    <th>Event Date</th>
                    <th>Status</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <>{
                    [...Array(10)].map((_, i) => (
                        <tr key={i}>
                            <td><span></span></td>
                            <td><span></span></td>
                            <td><span></span></td>
                            <td><span></span></td>
                        </tr>
                    ))
                }</>
            </tbody>
        </table>
    )
}

export default EventsLoader;